const KEY = 'fivl:recently-viewed';
const MAX = 12;

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '[]');
  } catch (error) {
    return [];
  }
};
const write = (ids) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(ids.slice(0, MAX)));
  } catch (error) {
    /* storage unavailable */
  }
};

// Remember the product being viewed.
const current = document.querySelector('product-page[data-product-id]')?.dataset.productId;
if (current) write([current, ...read().filter((id) => id !== current)]);

class RecentlyViewed extends HTMLElement {
  connectedCallback() {
    if (this.hasAttribute('data-loaded')) return;
    const exclude = this.dataset.exclude;
    const ids = read().filter((id) => id !== exclude).slice(0, Number(this.dataset.limit) || 4);
    if (!ids.length) return;
    this.load(ids);
  }
  async load(ids) {
    const query = ids.map((id) => `id:${id}`).join(' OR ');
    const url = `${window.FIVL.routes.search}?type=product&q=${encodeURIComponent(query)}&section_id=${this.dataset.sectionId}`;
    try {
      const response = await fetch(url);
      const text = await response.text();
      const fresh = new DOMParser().parseFromString(text, 'text/html').querySelector('recently-viewed');
      if (!fresh || !fresh.innerHTML.trim()) return;
      this.innerHTML = fresh.innerHTML;
      this.setAttribute('data-loaded', '');
      this.dispatchEvent(new CustomEvent('fivl:content', { bubbles: true }));
      this.hidden = false;
    } catch (error) {
      /* keep hidden */
    }
  }
}
if (!customElements.get('recently-viewed')) customElements.define('recently-viewed', RecentlyViewed);
